$(function(){
    const $footer = $('.site-footer');
    const footerDefaultHeight = $footer.outerHeight();
    const $mapContainer = $footer.find('.map-container');
    const $groupContent1 = $('.site-footer #group-content-1');

    if ($(window).width() >= 768) {
        // footer height adjust after newsletter form collapse
        $groupContent1.on('shown.bs.collapse', function() {
            // boostrap event
            $mapContainer.height($footer.outerHeight());
        });

        $groupContent1.on('hidden.bs.collapse', function() {
            // boostrap event
            $mapContainer.height(footerDefaultHeight);
        });

        $(window).on('viewportWidthHasChanged', function() {
            $mapContainer.height($footer.outerHeight());
        });
    }
});



// WEBPACK FOOTER //
// ./static/js/modules/footer.js